import { render } from "./UserWorkReportsSection.vue?vue&type=template&id=27db9cd8&scoped=true&ts=true&lang=pug"
import script from "./UserWorkReportsSection.vue?vue&type=script&lang=ts"
export * from "./UserWorkReportsSection.vue?vue&type=script&lang=ts"

import "./UserWorkReportsSection.vue?vue&type=style&index=0&id=27db9cd8&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27db9cd8"]])

export default __exports__